import { useState } from 'react';
import { Button, Modal, Stack, Text, Group } from '@mantine/core';
import { IconMailOpened } from '@tabler/icons-react';
import { useNotifications } from '../useNotifications';
import logger from '@ayocore/platform/common/helpers/logger';

/**
 * MarkAllReadModal - Modal component for confirming mark all as read action
 */
interface MarkAllReadModalProps {
  opened: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

function MarkAllReadModal({ opened, onClose, onConfirm }: MarkAllReadModalProps) {
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    setLoading(true);
    try {
      await onConfirm();
      onClose();
    } catch (error) {
      // Ошибка уже обработана в NotificationController
      logger.error('Failed to mark all as read:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal opened={opened} onClose={onClose} title='Прочитать все уведомления' size='sm' centered>
      <Stack gap='md'>
        <Text>Вы уверены, что хотите отметить все уведомления как прочитанные?</Text>
        <Group justify='flex-end' gap='sm'>
          <Button variant='light' onClick={onClose} color='gray' size='xs' disabled={loading}>
            Отмена
          </Button>
          <Button variant='filled' onClick={handleConfirm} color='blue' size='xs' loading={loading}>
            Прочитать всё
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}

/**
 * MarkAllReadButton - Compact button to mark all notifications as read
 */
export function MarkAllReadButton() {
  const { unreadCount, markAllAsRead } = useNotifications();
  const [opened, setOpened] = useState(false);

  if (unreadCount === 0) {
    return null;
  }

  return (
    <>
      <Button
        size='xs'
        variant='light'
        leftSection={<IconMailOpened size={14} />}
        onClick={() => setOpened(true)}
      >
        Прочитать всё
      </Button>

      <MarkAllReadModal
        opened={opened}
        onClose={() => setOpened(false)}
        onConfirm={markAllAsRead}
      />
    </>
  );
}
